import {NgModule} from '@angular/core';
import {PushNotificationsService} from './push-notifications.service';

@NgModule({
    providers: [PushNotificationsService]
})
export class PushNotificationsModule {}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./~/angular2-notifications/src/push-notifications.module.ts